import React, { useState } from "react";

const contactEmail = `contact@htec-fr.eu`;

function ContactForm() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    setStatus(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!contactEmail) {
      setStatus({
        type: "error",
        message: "La réception des messages sera activée dès que l'adresse e-mail de l'entreprise sera configurée.",
      });
      return;
    }

    setSubmitting(true);
    setStatus(null);
    try {
      const response = await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(contactEmail)}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          _subject: `Demande de contact HIA Technologie Group - ${formData.name}`,
          _captcha: true,
        }),
      });

      if (!response.ok) throw new Error("Contact form request failed");

      setFormData({ name: "", email: "", message: "" });
      setStatus({ type: "success", message: "Votre demande a bien été envoyée. Merci pour votre message." });
    } catch (error) {
      setStatus({
        type: "error",
        message: "L'envoi a échoué. Vous pouvez nous joindre directement par téléphone.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="contact-form-heading">
        <span className="form-mail-icon" aria-hidden="true">✉</span>
        <div>
          <h4>Écrivez-nous</h4>
          <p>Nous vous répondrons au sujet de votre demande.</p>
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="contact-name">Votre nom</label>
        <input
          id="contact-name"
          name="name"
          autoComplete="name"
          placeholder="Ex. Camille Martin"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="contact-email">Votre adresse e-mail</label>
        <input
          id="contact-email"
          name="email"
          type="email"
          autoComplete="email"
          placeholder="vous@entreprise.fr"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="contact-message">Votre besoin ou description</label>
        <textarea
          id="contact-message"
          name="message"
          placeholder="Décrivez votre projet, vos questions ou les logiciels concernés..."
          rows="5"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary contact-submit" disabled={submitting}>
        {submitting ? "Envoi en cours..." : "Envoyer ma demande"}
        <span aria-hidden="true">↗</span>
      </button>
      {status && (
        <p className={`form-status ${status.type}`} role="status" aria-live="polite">
          {status.message}
        </p>
      )}
    </form>
  );
}

export default ContactForm;